import { User } from '@tools/ui/types';
import { Scalars, SherlockUser } from '@tools/ui/types/generated/graphql';
import {
  handleSuccessResponse,
  Response
} from '@tools/ui-utils/response-handling.util';
import { axios as api } from './api';

const routePrefix = '/users';

export interface BulkCreateUsersRequest {
  emails: string[];
  roles?: string[];
  squads?: string[];
  status?: string;
}

export interface BulkCreateUsersResult {
  succeeded: string[];
  failed: { email: string; reason: string }[];
}

export const getCurrentUser = async (): Promise<User> => {
  return api.get(`${routePrefix}/getCurrentUser`);
};

export const getAllUsers = async (): Promise<User[]> => {
  return api.get(`${routePrefix}/getAllUsers`);
};

export const createUser = async (
  request: BulkCreateUsersRequest
): Promise<BulkCreateUsersResult> => {
  return api.post(`${routePrefix}`, request);
};

export const updateUser = async (
  user: Partial<SherlockUser>
): Promise<Response> => {
  return api.put(`${routePrefix}`, user).then(handleSuccessResponse);
};

export const deleteUser = async (
  userId: Scalars['MongoID']
): Promise<Response> => {
  return api
    .delete(`${routePrefix}`, { data: { _id: userId } })
    .then(handleSuccessResponse);
};
